import { TemplateIcon } from "@/components/shared/ReleaseIcons";

export const jobSettingsMenuItems = [
  "Configurations",
  {
    label: "Job Configuration",
    icon: TemplateIcon,
    slug: "configuration",
  },
  {
    label: "Environment Variables",
    icon: TemplateIcon,
    slug: "environment_variables",
  },
] as const;

type ExtractSlug<T> = T extends { slug: infer S } ? S : never;
export type JobSettingsMenuItem = ExtractSlug<(typeof jobSettingsMenuItems)[number]>;
